// extracted by mini-css-extract-plugin
export default {"text":"app_text__CHmO4","longText":"app_longText__aY53E","title":"app_title__BUFSA","button":"app_button__EW5DX","pageLink":"app_pageLink__T2uXN","app":"app_app__0RHs9"};